import { IGlobalState } from '../reducers';
import { IProjectionsState } from '../reducers/ProjectionsReducer';

/**
 * Gets the projection systems from the state
 * @param state
 */
export const getAllProjectionSystems = (state: IGlobalState) =>
  (state.ProjectionsReducer as IProjectionsState).allProjectionSystems;
